import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Building2 } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AdminLogin = () => {
  const [credentials, setCredentials] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, credentials);
      const { access_token } = response.data;
      
      // Store token
      localStorage.setItem('admin_token', access_token);
      localStorage.setItem('admin_email', credentials.email);
      
      toast.success('Login erfolgreich!');
      navigate('/admin/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      toast.error(error.response?.data?.detail || 'Login fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0A1628] to-[#153A5F]">
      <div className="w-full max-w-md px-4">
        {/* Logo */}
        <div className="text-center mb-8">
          <div
            className="w-20 h-20 rounded-xl flex items-center justify-center mx-auto mb-4 shadow-2xl"
            style={{ background: 'linear-gradient(135deg, #D4A853 0%, #F0C870 100%)' }}
          >
            <Building2 className="h-10 w-10 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">RetailInvest</h1>
          <p className="text-sm" style={{ color: 'var(--gold-400)' }}>Admin Login</p>
        </div>

        {/* Login Card */}
        <Card className="glass-card p-8">
          <form onSubmit={handleLogin}>
            <div className="space-y-6">
              <div>
                <Label htmlFor="email" className="text-gray-700">E-Mail</Label>
                <Input
                  id="email"
                  type="email"
                  data-testid="admin-email-input"
                  value={credentials.email}
                  onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
                  placeholder="admin@retail-invest.com"
                  required
                  className="mt-2"
                />
              </div>

              <div>
                <Label htmlFor="password" className="text-gray-700">Passwort</Label>
                <Input
                  id="password"
                  type="password"
                  data-testid="admin-password-input"
                  value={credentials.password}
                  onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                  placeholder="••••••••"
                  required
                  className="mt-2"
                />
              </div>

              <Button
                type="submit"
                disabled={loading}
                data-testid="admin-login-button"
                className="w-full btn-gold-gradient text-white border-0 font-semibold py-6"
              >
                {loading ? 'Anmelden...' : 'Anmelden'}
              </Button>
            </div>
          </form>
        </Card>
      </div>
    </div>
  );
};

export default AdminLogin;